module.exports = "/_next/static/images/Pin@3x-c311ffc94042e4c476720d8baa7c492f.png";